var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"input"},[_vm._t("input")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }